import { PureComponent } from 'react';

import { Flex, Text } from '@opendoor/bricks/core';
import Box from '@opendoor/bricks/core/Box';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';
import { AddressInput } from '@opendoor/cinderblocks/growth/AddressInput';
import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

import { GetReferralDashboardData_organization } from '../graphql/queries/__generated__/GetReferralDashboardData';
import { GOOGLE_MAPS_API_KEY } from '../helpers/globals';
import trackEvent from '../helpers/trackEvent';
import CheckProductEligibility from './CheckProductEligibility';
import { ContentWrapper } from './ContentWrapper';
import ProductEligibilityText from './ProductEligibilityText';
import RequestOffer from './RequestOffer';

export interface IState {
  address?: IAddressInputAddress;
}

export interface IProps {
  organization: GetReferralDashboardData_organization;
}

class ProductEligibilitySection extends PureComponent<IProps> {
  public state: IState = {
    address: undefined,
  };

  public render() {
    const { organization } = this.props;

    return (
      <ContentWrapper>
        <ContentCard title="Home Eligibility" borderRadius="roundedSquare">
          {/* eslint-disable-next-line react/jsx-pascal-case */}
          <Text fontSize="s1" lineHeight="s0">
            Check to see if a customer’s home is eligible for an Opendoor offer.
          </Text>
          <Box className="large-margin-top" fontSize="s00" position="relative">
            <AddressInput
              placeholderText="Enter home address"
              googleMapsApiKey={GOOGLE_MAPS_API_KEY}
              showCta={false}
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus={true}
              onSubmit={this.setAddress}
              unboundedWidth={true}
              showBorder={true}
              paddingLevel={'none'}
              showShadow={false}
              showError={true}
              hideErrorFormLink={true}
            />
            <CheckProductEligibility address={this.state.address} organization={organization} />
            <Flex alignItems="center" justifyContent="space-between" width="100%" flexWrap="wrap">
              <ProductEligibilityText address={this.state.address} />
              <Box width="200px" minWidth={'fit-content'} marginLeft="auto">
                <RequestOffer organization={organization} address={this.state.address} />
              </Box>
            </Flex>
          </Box>
        </ContentCard>
      </ContentWrapper>
    );
  }

  private setAddress = (address: IAddressInputAddress) => {
    const { organization } = this.props;
    trackEvent('input-address', 'product-eligibility', {
      address,
      partnershipType: organization.partnershipType,
      referralUrl: organization.referralUrl,
    });
    this.setState({ address });
  };
}

export default ProductEligibilitySection;
